
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.417 29.333H2.583c-.53 0-.968-.453-.968-1 0-.546.439-1 .968-1h25.834c.53 0 .968.454.968 1 0 .547-.439 1-.968 1z","fill":"#292D32"}}),_c('path',{attrs:{"d":"M12.594 5.333v24h5.812v-24c0-1.466-.581-2.666-2.325-2.666H14.92c-1.744 0-2.325 1.2-2.325 2.666zM3.875 13.333v16h5.167v-16c0-1.466-.517-2.666-2.067-2.666H5.942c-1.55 0-2.067 1.2-2.067 2.666zM21.958 20v9.333h5.167V20c0-1.467-.517-2.667-2.067-2.667h-1.033c-1.55 0-2.067 1.2-2.067 2.667z","fill":"#292D32"}})])
          )
        }
      }
    